import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod/v4";

const winLossSchema = z.object({ won: z.number(), lost: z.number() });

export const getReclaimWinRate = unaryRpc({
  name: "getReclaimWinRate" as const,
  input: z.object({}),
  output: z.object({
    week: winLossSchema,
    twoWeeks: winLossSchema,
    month: winLossSchema,
    allTime: winLossSchema,
  }),
});
